import { robotoRegular } from '@habitech/shared';
import styled from 'styled-components';

export const WrapperOrchestrator = styled.div`
  font-size: 14px;
  font-family: ${robotoRegular};
  .nid {
    font-size: 18px;
  }
`;
